"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const lab_1 = require("@mui/lab");
const Tabs = (props) => {
    const { variant = "standard", tabs, tabPanels, value, onChange } = props;
    return (react_1.default.createElement(lab_1.TabContext, { value: value },
        react_1.default.createElement(lab_1.TabList, { variant: variant, onChange: onChange, sx: { mb: 2 } }, tabs && tabs.map((tab) => react_1.default.createElement(material_1.Tab, { key: tab.value, ...tab }))),
        tabPanels && tabPanels.map((tabPanel) => react_1.default.createElement(lab_1.TabPanel, { key: tabPanel.value, sx: { p: 0 }, ...tabPanel }))));
};
exports.default = Tabs;
